import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    clusterSets: gql`
        query ClusterGroups($campaignID: String!, $includeIDs: Boolean) {
            clusterSets(campaignID: $campaignID, includeIDs: $includeIDs) {
                ... on ClusterResponse {
                    clusterSets {
                        ...ClusterSetFragment
                    }
                }
            }
        }

        ${fragments.cluster}
        ${fragments.clusterSet}
        ${fragments.clusterClass}
    `,
};
